import { EN_RAFFLE_DEAL_SUB_TAB, RaffleDealStoreCtx, TRaffleDealSubTab } from '@/stores/RaffleDealStore';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import React, { useContext, useEffect, useMemo } from 'react';

import RaffleDealProductUnit from '../Unit/RaffleDealProductUnit';
import styles from './RaffleDealHistoryBody.module.scss';
import RaffleDealHistoryPagination from './RaffleDealHistoryPagination';

const RaffleDealHistoryBody: React.FC = () => {
  const store = useContext(RaffleDealStoreCtx);

  const subTabs = Object.keys(EN_RAFFLE_DEAL_SUB_TAB) as TRaffleDealSubTab[];

  const onClickSubTab = (tab: TRaffleDealSubTab): void => {
    store.resetPagination();
    store.setActiveSubTab(tab);
  };

  useEffect(() => {
    if (store.activeSubTab === 'WIN') {
      store.getWinHistory();
    } else {
      store.getHistory(store.activeSubTab);
    }
  }, [store.activeSubTab, store.currentPage]);

  const renderHistory = useMemo((): JSX.Element => {
    if (!store.historyData || store.historyData.totalElements === 0) {
      return (
        <div className={styles.empty}>
          {store.activeSubTab === 'ALL' ? (
            <img src="https://image6.yanolja.com/promotion/CkI3eDw85eIzKZhb" alt="아직 진행내역이 없습니다" />
          ) : (
            <img src="https://image6.yanolja.com/promotion/AG1641erKaH7sFEz" alt="아직 응모내역이 없습니다" />
          )}
        </div>
      );
    }

    return (
      <div className={styles.listWrap}>
        {<p className={styles.total}>총 {store.historyData.totalElements}개</p>}

        <div>
          {store.historyData.content.map((deal) => (
            <RaffleDealProductUnit key={deal.id} deal={deal} />
          ))}
        </div>
      </div>
    );
  }, [store.historyData, store.activeSubTab]);

  const renderWinHistory = useMemo((): JSX.Element => {
    if (!store.winHistoryData || store.winHistoryData.totalElements === 0) {
      return (
        <div className={styles.empty}>
          <img src="https://image6.yanolja.com/promotion/YB1w2TT4aNnqZYXB" alt="아쉽게도 당첨내역이 없습니다" />
        </div>
      );
    }
    return (
      <div className={styles.listWrap}>
        {<p className={styles.total}>총 {store.winHistoryData.totalElements}개</p>}

        <div>
          {store.winHistoryData.content.map((deal, idx) => (
            <RaffleDealProductUnit key={idx} deal={deal} />
          ))}
        </div>
      </div>
    );
  }, [store.winHistoryData]);

  return (
    <section>
      <ul className={styles.subTabWrap}>
        {subTabs.map((tab, idx) => (
          <li
            key={idx}
            className={clsx([styles.subTab, store.activeSubTab === tab && styles.active])}
            onClick={() => onClickSubTab(tab)}
          >
            {EN_RAFFLE_DEAL_SUB_TAB[tab]}
          </li>
        ))}
      </ul>

      {store.activeSubTab === 'WIN' ? renderWinHistory : renderHistory}

      <RaffleDealHistoryPagination />
    </section>
  );
};

export default observer(RaffleDealHistoryBody);
